const API_URL = process.env.REACT_APP_API_URL;

export const authenticatedFetch = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token');

    const defaultHeaders = {
        'Content-Type': 'application/json',
    };

    if (token) {
        defaultHeaders['Authorization'] = `Bearer ${token}`;
    }

    const config = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
    };

    if (options.body && typeof options.body === 'object') {
        config.body = JSON.stringify(options.body);
    }

    try {
        const response = await fetch(`${API_URL}${endpoint}`, config);
        const data = await response.json();

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
                throw new Error('Session expired');
            }

            // For 429 errors, include the limit_reached flag in the error
            if (response.status === 429 && data.limit_reached) {
                const error = new Error(data.error || 'Limit reached');
                error.limitReached = true;
                throw error;
            }

            throw new Error(data.error || 'An error occurred');
        }

        return data;
    } catch (error) {
        console.error('API call error:', error);
        throw error;
    }
};